import React, { memo } from 'react';
import Typography from '@material-ui/core/Typography';
import { normalizeSourcingMessage } from 'features/ai-assistant/utils';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import { EntityType } from 'UI/constants/entityTypes';
import { formatNumber } from 'UI/utils';

import { COUNT_TEMPLATE_BY_TYPE } from './MessageMetaData.constants';
import { useMessageMetaDataStyles } from './MessageMetaData.styled';

export const MessageMetaData = memo(
  ({ entityType = EntityType.Candidate, message, onClick, isActive }) => {
    const data = normalizeSourcingMessage(message);
    const classes = useMessageMetaDataStyles({ isActive });

    if (!data) return null;

    const handleClick = () => {
      onClick({ id: data.id });
    };

    const handleKeyDown = event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleClick();
      }
    };

    return (
      <div
        className={classes.metaDataContainer}
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        <Typography variant="subtitle2">
          {strings.formatString(COUNT_TEMPLATE_BY_TYPE[entityType], {
            count: formatNumber(data.count)
          })}
        </Typography>
        <When condition={data.description}>
          <Typography variant="body2">{data.description}</Typography>
        </When>
      </div>
    );
  }
);
